/**
     * @desc 8下架我的用户盲盒，不调合约，直接下架，TransactionHash=download+时间戳，例如：downlad12345678907652356
用于：个人盲盒列表页，下架成功合并同类盲盒
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/box/downloadMyUserBox', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/box/downloadMyUserBox', params);
}
